var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('SongSearchBar',{staticClass:"p-4"}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }